const constants = Object.freeze({
	CURRENCY_CODE_EUR: '&#8364;',
	CURRENCY_CODE_GBP: '&#163;',
	CURRENCY_CODE_USD: '&#36;',
	CURRENCY_CODE_CAD: '&#36;',

	IMAGE_ECOM_PAY_BLACK: 'https://space-live.ams3.cdn.digitaloceanspaces.com/ecompay/black-elockers-logo.svg',
	IMAGE_ECOM_PAY: 'https://space-live.ams3.cdn.digitaloceanspaces.com/ecompay/elockers-logo.svg',
	IMAGE_CHRISTMAS_GARLAND: 'https://space-live.ams3.cdn.digitaloceanspaces.com/ecompay/garland.png',

	THEME_DEFAULT: 'default',
	THEME_CHIRSTMAS: 'christmas',
});

module.exports = constants;
